import React, { useEffect, useState } from "react";
import { api } from "../lib/staffApi";

/* Shown on every page when the server runs with APP_ENV=sandbox (public GET /api/sandbox/status). */
export default function SandboxBanner() {
  const [status, setStatus] = useState(null);
  useEffect(() => {
    api.get("/sandbox/status").then((r) => setStatus(r.data)).catch(() => setStatus(null));
  }, []);
  if (!status?.sandbox) return null;
  return (
    <div className="sticky top-0 z-[60] w-full bg-amber-400 px-4 py-1.5 text-center text-xs font-semibold text-black" data-testid="sandbox-banner">
      {status.banner || "SANDBOX - test data and test payments"}
    </div>
  );
}
